import GlobalNavMenuItem from './GlobalNavMenuItem';
export default GlobalNavMenuItem;
